// extracted by mini-css-extract-plugin
module.exports = {"doctor-about-container":"DoctorAbout_doctor-about-container__1OGim","data-container":"DoctorAbout_data-container__1cuOw"};